import * as firebase from "firebase"
require("firebase/firestore")

export const getDocumentsFromCollection = (collection, references) => {
  let collectionRef = firebase.firestore().collection(collection)
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(async doc => {
          let data = doc.data()

          let references_data = {}
          if (references) {
            for (let reference of references) {
              if (data[reference]) {
                references_data[reference] = {}
                await data[reference].get().then(reference_result => {
                  let reference_data = reference_result.data()
                  reference_data.id = reference_result.id
                  data[reference] = reference_data
                })
              }
            }
          }

          results.push({
            id: doc.id,
            ...data
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const createPlan = plan => {
  let document = firebase.firestore().collection("plans").doc()
  return document
    .set({
      name: plan.name,
      description: plan.description,
      price: plan.price,
      cycle: plan.cycle
    })
    .then(() => {
      return document
    })
    .catch(error => {
      throw error
    })
}

export const updatePlan = plan => {
  let document = firebase.firestore().collection("plans").doc(plan.id)
  return document
    .update({
      name: plan.name,
      description: plan.description,
      price: plan.price,
      cycle: plan.cycle
    })
    .then(() => {
      return document
    })
    .catch(error => {
      throw error
    })
}

export const removePlan = id => {
  let document = firebase.firestore().collection("plans").doc(id)
  return document
    .delete()
    .then(() => {
      return true
    })
    .catch(error => {
      throw error
    })
}
